// extracted by css-extract-rspack-plugin
export default {"quantityFieldScope":"quantityFieldScope-GLAvlu"};